(function () {
  var processed = new WeakSet();

  function moveVoteIcons() {
    document.querySelectorAll('.yotpo-review-votes-wrapper').forEach(function (wrapper) {
      if (processed.has(wrapper)) return;

      var sibling = wrapper.previousElementSibling;
      while (sibling && !sibling.classList.contains('yotpo-review')) {
        sibling = sibling.previousElementSibling;
      }
      if (!sibling) return;

      var iconsWrapper = wrapper.querySelector('.yotpo-review-votes-icons-wrapper');
      if (!iconsWrapper) return;

      var rightPanel = sibling.querySelector('.yotpo-review-right-panel');
      if (!rightPanel) return;

      rightPanel.appendChild(iconsWrapper);
      processed.add(wrapper);
      wrapper.remove();
    });
  }

  var observer = new MutationObserver(function (mutations) {
    var shouldRun = mutations.some(function (m) {
      return m.addedNodes.length > 0;
    });
    if (shouldRun && document.querySelector('.yotpo-review-votes-wrapper')) {
      moveVoteIcons();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (document.querySelector('.yotpo-review-votes-wrapper')) moveVoteIcons();
    });
  } else {
    if (document.querySelector('.yotpo-review-votes-wrapper')) moveVoteIcons();
  }
})();
